import React, { useState } from 'react';
import { FiSettings } from 'react-icons/fi';

const Namuna9RegisterRpt = () => {
  // Word data mapping for auto-population (same as magnipavti and Japti)
  const wordData = {
    '1': { receiptNumber: '101', ownerName: 'shubham', propertyNo: '11' },
    '2': { receiptNumber: '12', ownerName: 'sangram', propertyNo: '102' },
    '3': { receiptNumber: '13', ownerName: 'sagar', propertyNo: '103' }
  };

  const [filters, setFilters] = useState({
    orderBy: 'नावानुसार',
    startPage: '0',
    pageLimit: '300',
    wardName: '',
    ownerName: '',
    propertyNo: '',
    taxpayerName: ''
  });

  // Dummy data for display
  const [records] = useState([
    { id: 1, propertyNo: '001/2024', receiptNo: 'R-001', ownerName: 'राजेश पाटील', wardName: 'वॉर्ड १', address: 'शिवाजी रोड', taxAmount: '5,000', status: 'भरलेले' },
    { id: 2, propertyNo: '002/2024', receiptNo: 'R-002', ownerName: 'सुनीता देशमुख', wardName: 'वॉर्ड २', address: 'गांधी चौक', taxAmount: '7,500', status: 'थकित' },
    { id: 3, propertyNo: '003/2024', receiptNo: 'R-003', ownerName: 'विकास शर्मा', wardName: 'वॉर्ड १', address: 'नेहरू नगर', taxAmount: '6,200', status: 'भरलेले' },
    { id: 4, propertyNo: '004/2024', receiptNo: 'R-004', ownerName: 'प्रिया कुलकर्णी', wardName: 'वॉर्ड ३', address: 'राजीव गांधी मार्ग', taxAmount: '8,900', status: 'थकित' },
    { id: 5, propertyNo: '005/2024', receiptNo: 'R-005', ownerName: 'अमित जोशी', wardName: 'वॉर्ड २', address: 'सदाशिव पेठ', taxAmount: '4,500', status: 'भरलेले' },
  ]);

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  // Handle word name change to auto-populate other fields
  const handleWardNameChange = (value) => {
    const wordInfo = wordData[value] || { receiptNumber: '', ownerName: '', propertyNo: '' };
    setFilters({
      ...filters,
      wardName: value,
      ownerName: wordInfo.receiptNumber, // Map to receiptNumber field
      propertyNo: wordInfo.propertyNo,
      taxpayerName: wordInfo.ownerName // Map to taxpayerName field
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white p-4 rounded-t-lg shadow-md">
        <h1 className="text-xl font-bold">नमुना ९ रजिस्टर</h1>
      </div>

      {/* Main Content */}
      <div className="bg-white shadow-lg rounded-b-lg p-6">
        {/* Filter Row 1 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
          <div className="flex items-center gap-2">
            <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
              Order By
            </label>
            <select
              value={filters.orderBy}
              onChange={(e) => handleFilterChange('orderBy', e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="मालमत्ता न">मालमत्ता न</option>
              <option value="पावती नं">पावती नं</option>
              <option value="नाव">नाव</option>
            </select>
          </div>

          <div className="flex items-center gap-2">
            <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
              पासून :
            </label>
            <input
              type="text"
              value={filters.startPage}
              onChange={(e) => handleFilterChange('startPage', e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="0"
            />
          </div>

          <div className="flex items-center gap-2">
            <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">
              पर्यंत :
            </label>
            <input
              type="text"
              value={filters.pageLimit}
              onChange={(e) => handleFilterChange('pageLimit', e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="300"
            />
          </div>

          <div>
            <p className="text-sm text-red-600 font-medium">
              थकबाकी आणि घरपट्टी माहिती प्रदर्शित (रुपये 1,400:401-4:00)
            </p>
          </div>
        </div>

        {/* Filter Row 2 */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              वॉर्डचे नाव
            </label>
            <div className="flex items-center gap-2">
              <select
                value={filters.wardName}
                onChange={(e) => handleWardNameChange(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">निवडा</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
              <button className="text-red-500 hover:text-red-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              
 पावती नंबर
  
            </label>
            <input
              type="text"
              value={filters.ownerName}
              onChange={(e) => handleFilterChange('ownerName', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="निवडा"
              readOnly={filters.wardName !== ''}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              मालमत्ता क्र.
            </label>
            <input
              type="text"
              value={filters.propertyNo}
              onChange={(e) => handleFilterChange('propertyNo', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="निवडा"
              readOnly={filters.wardName !== ''}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              मालकाचे नाव
            </label>
            <input
              type="text"
              value={filters.taxpayerName}
              onChange={(e) => handleFilterChange('taxpayerName', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="निवडा"
              readOnly={filters.wardName !== ''}
            />
          </div>
        </div>

        {/* Data Table */}
        <div className="mb-6 overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead className="bg-blue-100">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">अ.क्र.</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">मालमत्ता क्र.</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">पावती क्र.</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">मालकाचे नाव</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">वॉर्ड</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">पत्ता</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">कर रक्कम</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-800 border border-gray-300">स्थिती</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record, index) => (
                <tr key={record.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{index + 1}</td>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{record.propertyNo}</td>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{record.receiptNo}</td>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{record.ownerName}</td>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{record.wardName}</td>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{record.address}</td>
                  <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">₹ {record.taxAmount}</td>
                  <td className="px-4 py-3 text-sm border border-gray-300">
                    <span className={`px-2 py-1 rounded text-xs font-medium ${record.status === 'भरलेले' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {record.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-3">
          <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded font-medium transition-colors">
            नवीन
          </button>
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded font-medium transition-colors flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clipRule="evenodd" />
            </svg>
            Print
          </button>
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium transition-colors">
            Export Excel
          </button>
          <button className="bg-cyan-400 hover:bg-cyan-500 text-white p-2 rounded transition-colors">
            <FiSettings size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Namuna9RegisterRpt;
